import SiafLiteApiRepository from "../../external/siafLiteApi";

class OrdemServicosPagamentosService {
  constructor() {
    this.urlBase = "/faturamento/ordem-servicos-pagamentos";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  deletarEmLote(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }
}

export default OrdemServicosPagamentosService;
